import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { planzone } from "@planzone/dto";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createSelector } from "./selector";
import { State, Selector } from "./types";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  planzone,
  timesheetDeadline: null,
};

function handleRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess({
  planzone,
  timesheetDeadline,
}: Boundaries["editTimesheetDeadline"]["success"]): State {
  return {
    request: setRequestStateToSuccess(),
    planzone,
    timesheetDeadline,
  };
}

function handleFailure({
  planzone,
  timesheetDeadline,
}: Boundaries["editTimesheetDeadline"]["failure"]): State {
  return {
    request: setRequestStateToFailure(),
    planzone,
    timesheetDeadline,
  };
}

const reduceState = createStateReducer(initialState, {
  [events.editTimesheetDeadlineRequested]: handleRequest,
  [events.editTimesheetDeadlineSucceeded]: handleSuccess,
  [events.editTimesheetDeadlineFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
